<div class="eldeco-page">
    <header class="eldeco-header">
        <div class="w">
            <div class="logo">ELDECO<small>GROUP</small></div>
            <img src="assets/images/eldeco/bajaj-capital-logo.png" alt="Bajaj Capital">
        </div>
    </header>

    <main class="eldeco-main">
        <div class="w2">
            <div>
                <p class="eyebrow">Real Estate Advisory</p>
                <h1>Talk to<br>Bajaj Capital.</h1>
                <div class="rule"></div>
            </div>

            <div class="card">
                <!-- Lead Form -->
                <form *ngIf="isLeadFormVisible" #leadForm="ngForm" (ngSubmit)="PostData(leadForm)" novalidate>
                    <h2>Discover Your Next Address</h2>
                    <p class="sub">Get project details and connect with our property advisor.</p>

                    <label for="name">Full Name <span class="required" aria-hidden="true">*</span></label>
                    <input type="text" id="name" name="name" [(ngModel)]="name" autocomplete="name" maxlength="40"
                        oninput="this.value = this.value.replace(/[^a-zA-Z\s]/g, '').replace(/\s{2,}/g, ' ');"
                        (keydown)="alphaOnly($event)" (focus)="removeErrorMsg('name')">
                    <div class="err" *ngIf="nameValidateMessage == 'required'">Enter your full name.</div>
                    <div class="err" *ngIf="nameValidateMessage == 'lengthError'">Enter a valid full name.</div>

                    <label for="mobile">Mobile Number <span class="required" aria-hidden="true">*</span></label>
                    <input type="tel" id="mobile" name="mobile" [(ngModel)]="mobile" inputmode="numeric"
                        autocomplete="tel" maxlength="10" (keydown.space)="$event.preventDefault();"
                        oninput="this.value = this.value.replace(/[^0-9]/g, '');" (keypress)="numbersOnly($event)"
                        (focus)="removeErrorMsg('mobile')">
                    <div class="err" *ngIf="mobileValidateMessage == 'required'">Enter your mobile number.</div>
                    <div class="err" *ngIf="mobileValidateMessage == 'lengthError'">Enter a valid 10-digit mobile number.</div>
                    <div class="err" *ngIf="mobileValidateMessage == 'invalid'">Enter a valid mobile number.</div>

                    <label for="email">Email Address <span class="required" aria-hidden="true">*</span></label>
                    <input type="email" id="email" name="email" [(ngModel)]="email" autocomplete="email" maxlength="50"
                        (keydown.space)="$event.preventDefault();" (focus)="removeErrorMsg('email')">
                    <div class="err" *ngIf="emailValidateMessage == 'required'">Enter your email address.</div>
                    <div class="err" *ngIf="emailValidateMessage == 'invalid'">Enter a valid email address.</div>

                    <button class="btn" type="submit">Request a Private Consultation</button>
                    <p class="note">Your information is confidential.</p>
                </form>

                <!-- OTP Form -->
                <form *ngIf="isOtpFormVisible" #otpForm="ngForm" (ngSubmit)="SubmitOTP(otpForm)" novalidate>
                    <h2>Verify Your Number</h2>
                    <p class="sub">We've sent a 6-digit OTP to {{ displayMobile }}.
                        <a href="javascript:void(0)" class="link" (click)="changeNumber()">Change number</a>
                    </p>

                    <label for="otp">One-Time Password</label>
                    <input type="text" id="otp" name="otp" [(ngModel)]="userOTP" inputmode="numeric"
                        autocomplete="one-time-code" maxlength="6" (keydown.space)="$event.preventDefault();"
                        (keypress)="numbersOnlyotp($event)" (keyup)="removeErrorMsg('otp')">
                    <div class="err" *ngIf="!otpVerifiedStatus">Invalid OTP.</div>
                    <div class="err" *ngIf="otpValidateMessage == 'required'">Enter the OTP to continue.</div>
                    <div class="err" *ngIf="otpValidateMessage == 'lengthError'">Enter the 6-digit OTP.</div>

                    <button class="btn" type="submit" [disabled]="isVerifying">
                        {{ isVerifying ? 'Verifying…' : 'Verify &amp; Submit' }}
                    </button>
                    <p class="note">
                        <span *ngIf="isTimer">Didn't receive the OTP? Resend in <strong>{{ timeleft }}</strong> seconds</span>
                        <a href="javascript:void(0)" class="link" *ngIf="isResend" (click)="resendOTP()">Resend OTP</a>
                    </p>
                </form>

                <!-- Thank You -->
                <div class="thanks" *ngIf="isThanksVisible" role="status">
                    <h2>Thank you</h2>
                    <p class="sub">Our property advisor will reach out to you shortly.</p>
                </div>
            </div>
        </div>
    </main>
</div>
